 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"bodymass-classroom":"bodymass-classroom","classroom-comment":"classroom-comment","classroom-confirm-grade~classroom-report~classrooms~classrooms-manage~dashboard~file-upload~holidays~42eb8d05":"classroom-confirm-grade~classroom-report~classrooms~classrooms-manage~dashboard~file-upload~holidays~42eb8d05","classroom-confirm-grade":"classroom-confirm-grade","classroom-report":"classroom-report","classrooms":"classrooms","classrooms-manage~holidays~roll-call~room~students~term-settings":"classrooms-manage~holidays~roll-call~room~students~term-settings","classrooms-manage":"classrooms-manage","holidays":"holidays","register~room~school-settings":"register~room~school-settings","reports~room~teacher-dashboard":"reports~room~teacher-dashboard","room":"room","students":"students","term-settings":"term-settings","dashboard~home":"dashboard~home","dashboard":"dashboard","home":"home","file-upload~import-crews~new-student~users":"file-upload~import-crews~new-student~users","file-upload~import-crews~new-student":"file-upload~import-crews~new-student","file-upload":"file-upload","import-crews":"import-crews","new-student":"new-student","school-settings~users":"school-settings~users","users":"users","reports":"reports","student-report":"student-report","classroom-report-print~student-report-print":"classroom-report-print~student-report-print","classroom-report-print":"classroom-report-print","student-report-print":"student-report-print","roll-call":"roll-call","create-dev-form":"create-dev-form","dental-classroom":"dental-classroom","dev-form":"dev-form","evaluate-classroom":"evaluate-classroom","evaluate-student":"evaluate-student","forgot-password":"forgot-password","health":"health","log-in":"log-in","profile":"profile","register":"register","school-settings":"school-settings","teacher-dashboard":"teacher-dashboard","room-dev-form":"room-dev-form","sighthearing-classroom":"sighthearing-classroom","student-information":"student-information"}[chunkId]||chunkId) + "." + {"bodymass-classroom":"569f3495","classroom-comment":"df055945","classroom-confirm-grade~classroom-report~classrooms~classrooms-manage~dashboard~file-upload~holidays~42eb8d05":"3f0718b5","classroom-confirm-grade":"28e71118","classroom-report":"3c011908","classrooms":"08b5420c","classrooms-manage~holidays~roll-call~room~students~term-settings":"7d38bf19","classrooms-manage":"9bdf1235","holidays":"167882e9","register~room~school-settings":"a17bd042","reports~room~teacher-dashboard":"7a522ff7","room":"0fe7dc8c","students":"4ba5e9ad","term-settings":"c1bb47e6","dashboard~home":"9fe32eac","dashboard":"f47cc276","home":"8e35d1da","file-upload~import-crews~new-student~users":"85e53560","file-upload~import-crews~new-student":"03d162dc","file-upload":"f9212286","import-crews":"dcd6c4a4","new-student":"1e5b1dbc","school-settings~users":"73b28a7d","users":"3b9a64e4","reports":"9db720a7","student-report":"ed2355b1","classroom-report-print~student-report-print":"472243c8","classroom-report-print":"784b30ba","student-report-print":"e520f46a","roll-call":"02fc4e49","create-dev-form":"262e9e50","dental-classroom":"679912ba","dev-form":"6986f996","evaluate-classroom":"1a737c01","evaluate-student":"49c34012","forgot-password":"69890a79","health":"ec7ea9f9","log-in":"3f10b0ed","profile":"4fd2cf37","register":"adb98225","school-settings":"3fc9b093","teacher-dashboard":"914a753d","room-dev-form":"6ecf0df8","sighthearing-classroom":"94de108f","student-information":"f2bda4e0"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"classroom-comment":1,"classroom-confirm-grade~classroom-report~classrooms~classrooms-manage~dashboard~file-upload~holidays~42eb8d05":1,"classroom-confirm-grade":1,"classroom-report":1,"classrooms":1,"classrooms-manage~holidays~roll-call~room~students~term-settings":1,"classrooms-manage":1,"holidays":1,"register~room~school-settings":1,"room":1,"students":1,"term-settings":1,"dashboard~home":1,"dashboard":1,"home":1,"file-upload":1,"users":1,"classroom-report-print~student-report-print":1,"classroom-report-print":1,"student-report-print":1,"create-dev-form":1,"evaluate-classroom":1,"forgot-password":1,"health":1,"profile":1,"school-settings":1,"student-information":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"bodymass-classroom":"bodymass-classroom","classroom-comment":"classroom-comment","classroom-confirm-grade~classroom-report~classrooms~classrooms-manage~dashboard~file-upload~holidays~42eb8d05":"classroom-confirm-grade~classroom-report~classrooms~classrooms-manage~dashboard~file-upload~holidays~42eb8d05","classroom-confirm-grade":"classroom-confirm-grade","classroom-report":"classroom-report","classrooms":"classrooms","classrooms-manage~holidays~roll-call~room~students~term-settings":"classrooms-manage~holidays~roll-call~room~students~term-settings","classrooms-manage":"classrooms-manage","holidays":"holidays","register~room~school-settings":"register~room~school-settings","reports~room~teacher-dashboard":"reports~room~teacher-dashboard","room":"room","students":"students","term-settings":"term-settings","dashboard~home":"dashboard~home","dashboard":"dashboard","home":"home","file-upload~import-crews~new-student~users":"file-upload~import-crews~new-student~users","file-upload~import-crews~new-student":"file-upload~import-crews~new-student","file-upload":"file-upload","import-crews":"import-crews","new-student":"new-student","school-settings~users":"school-settings~users","users":"users","reports":"reports","student-report":"student-report","classroom-report-print~student-report-print":"classroom-report-print~student-report-print","classroom-report-print":"classroom-report-print","student-report-print":"student-report-print","roll-call":"roll-call","create-dev-form":"create-dev-form","dental-classroom":"dental-classroom","dev-form":"dev-form","evaluate-classroom":"evaluate-classroom","evaluate-student":"evaluate-student","forgot-password":"forgot-password","health":"health","log-in":"log-in","profile":"profile","register":"register","school-settings":"school-settings","teacher-dashboard":"teacher-dashboard","room-dev-form":"room-dev-form","sighthearing-classroom":"sighthearing-classroom","student-information":"student-information"}[chunkId]||chunkId) + "." + {"bodymass-classroom":"31d6cfe0","classroom-comment":"bd1fd07a","classroom-confirm-grade~classroom-report~classrooms~classrooms-manage~dashboard~file-upload~holidays~42eb8d05":"5d31b755","classroom-confirm-grade":"277bba3f","classroom-report":"a13bed86","classrooms":"1e151bfc","classrooms-manage~holidays~roll-call~room~students~term-settings":"1588e432","classrooms-manage":"eb3a1f07","holidays":"db969758","register~room~school-settings":"4ea1df0e","reports~room~teacher-dashboard":"31d6cfe0","room":"f01cdf0d","students":"db969758","term-settings":"db969758","dashboard~home":"bb8aa7ad","dashboard":"63fdb0d9","home":"e6521c54","file-upload~import-crews~new-student~users":"31d6cfe0","file-upload~import-crews~new-student":"31d6cfe0","file-upload":"f4f0bead","import-crews":"31d6cfe0","new-student":"31d6cfe0","school-settings~users":"31d6cfe0","users":"f613609a","reports":"31d6cfe0","student-report":"31d6cfe0","classroom-report-print~student-report-print":"c7ff851b","classroom-report-print":"74b9e7c2","student-report-print":"13e63197","roll-call":"31d6cfe0","create-dev-form":"cdccee1e","dental-classroom":"31d6cfe0","dev-form":"31d6cfe0","evaluate-classroom":"4ea1df0e","evaluate-student":"31d6cfe0","forgot-password":"51e01ee4","health":"db969758","log-in":"31d6cfe0","profile":"9c890a6d","register":"31d6cfe0","school-settings":"39948a95","teacher-dashboard":"31d6cfe0","room-dev-form":"31d6cfe0","sighthearing-classroom":"31d6cfe0","student-information":"db969758"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
